module.exports = __webpack_public_path__ + "img/20210117_105133.2baa0f31.jpg";